import { QueryClient, useMutation } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';
import removeEmpty from '../../../utils/removeEmptyValuesFromObject';

const addPOQuery = (data) => {
    const cleanedData = removeEmpty(data);
    return axios.post(apiurl?.addPO, cleanedData);
};

const addPO = () => {
    const queryClient = new QueryClient();
    return useMutation(['addPO'], addPOQuery, {
        onSuccess: () => {
            queryClient.invalidateQueries('getPOList');
        }
    });
};

export default addPO;
